<template>
  <div class="flex items-center gap-2 sm:gap-4 w-full justify-between">
    <div class="flex items-center gap-2 sm:gap-4">
      <div :class="step >= 3 ? 'activeInstitution' : 'inActiveInstitution'">
        <v-hand-heart-outline></v-hand-heart-outline>
      </div>
      <div 
        :class="step >= 3 ? 'text-pdsPrimaryColor' : 'text-gray-300'" 
        class="font-bold text-xl leading-snug"
        >
        Rol & behandelgebieden
      </div>
    </div>
    <div 
       v-if="step > 3"
       class="cursor-pointer text-pdsPrimaryColor text-sm font-semibold" 
       @click="editRoleDetails"
       >
      Wijzigen
    </div>
  </div>
  <div v-if="step == 3">
    <div class="mt-2 flex flex-col">
      <label v-if="selectedtreatmentArea?.data" class="font-bold text-lg leading-6 text-gray-700 mt-4">
        Behandelgebied(en):
        <span class="font-semibold text-sm">
          {{
          details?.treatmentAreas
          ?.filter((a) => a.active)
          .map((a) => a.treatmentArea)
          .join(' , ')
          }}
        </span>
      </label>
      <label class="font-bold text-base leading-6 text-cyan-900">Voor welke behandelgebieden schrijft u voor?*</label>
      <combo-boxes 
        customClass="text-base leading-6 text-cyan-900" 
        placeholder="Kies behandelgebied"
        v-model="selectedtreatmentArea" 
        @blur="saveTreatmentArea($event)" 
        :list="treatmentAreaList" 
        :rules="{
          required: true
        }" :disabled="disableTreatmentArea">
      </combo-boxes>
      <div>
        <label class="font-bold text-base leading-6 text-cyan-900">Rol*</label>
        <combo-boxes 
          customClass="text-base leading-6 text-cyan-900" 
          placeholder="Kies een rol" 
          v-model="selectedRole"
          :list="rolesList" 
          :rules="{
          required: true
        }">
        </combo-boxes>
      </div>
    </div>
  </div>

  <div v-if="step > 3" class="mt-2 text-gray-700 text-sm sm:text-base break-words whitespace-normal">
    <div v-if="selectedtreatmentArea.data" class="font-bold text-sm leading-6 text-cyan-900 mt-4">
      Behandelgebied(en):
      <span class="font-semibold text-sm">{{
        details?.treatmentAreas
        ?.filter((a) => a.active)
        .map((a) => a.treatmentArea)
        .join(' , ')
        }}
      </span>
    </div>
    <div v-if="selectedRole" class="font-bold text-sm leading-6 text-cyan-900">
      Rol:
      <span class="font-semibold text-sm">{{ selectedRole.data }} </span>
    </div>
  </div>
  <div v-if="step >= 3" class="pt-2">
    <button :class="{
      'text-center text-white px-5 py-3 rounded-full border bg-gray-300 border-gray-300 cursor-default':
        !disableSave,
      'text-center text-white cursor-pointer bg-pdsPrimaryColor px-5 py-3 rounded-full border border-pdsPrimaryColor':
        disableSave
    }" 
    @click.once.prevent="saveRoleDetails">
      Registratie voltooien
    </button>
  </div>
</template>

<script>
import { ref, onMounted, computed} from 'vue';
import VHandHeartOutline from 'icons/HandHeartOutline';
import { useStore } from 'vuex';

export default {
  name: 'accountRegistrationRoleDetail',
  components: { VHandHeartOutline },
  props: {
    details: {
      type: Object,
      required: true
    },
    step: { type: Number, default: 0 }
  },
  emits: ['setRoleDetails'],
  setup(props, { emit }) {
    const store = useStore();
    const selectedtreatmentArea = ref({ id: '', data: '' });
    const selectedRole = ref({ id: '', data: '' });
    const treatmentAreaList = ref([]);
    const rolesList = ref([]);
    const disableTreatmentArea = ref(false);
    const setRoles = (value) => store.commit('accountRegistration/setRoles', value);
    const setPrescriberTreatmentArea = (value) => store.commit('accountRegistration/setPrescriberTreatmentArea', value);
    const resetPrescriberTreatmentArea = (value) => store.commit('accountRegistration/clearPrescriberTreatmentAreas');
    const disableSave = computed(() => {
      if (selectedRole.value?.id && selectedtreatmentArea?.value.id) {
        return true;
      } else {
        return false;
      }
    });
  
    const getTreatmentAreaList = () => {
      if (props.details && props.details.treatmentAreas) {
        let treatmentAreas = props.details.treatmentAreas;
        treatmentAreas.map((element, item) => {
          treatmentAreaList.value.push({ id: element.treatmentAreaId, data: element.treatmentArea });
        });
      }
    };
    const getRolesList = () => {
      if (props.details && props.details.gpRoles) {
        let roles = props.details.gpRoles;
        roles.map((element) => {
          rolesList.value.push({ id: element.roleId, data: element.role });
        });
      }
    };
    function saveRoleDetails () {
      if (selectedRole.value.id) {
        setRoles({ id: selectedRole.value.id, active: true });
        emit('setRoleDetails', 4);
      }
    };
    const saveTreatmentArea = (event) => {
      if (selectedtreatmentArea.value.id) {
        setPrescriberTreatmentAreaa({ id: selectedtreatmentArea.value.id, active: true });
      }
    };
    const setPrescriberTreatmentAreaa = (treatmentArea) => {
      // for gp portal disable another treatment areas
      if (treatmentArea.id == '1010') {
        props.details.treatmentAreas?.forEach((item) => {
          item.active = item.treatmentAreaId === '1010';
        });
      } else {
        let gpTreatmentIndex = props.details.treatmentAreas.findIndex(
          (item) => item.treatmentAreaId === '1010'
        );
        if (gpTreatmentIndex) {
          props.details.treatmentAreas[gpTreatmentIndex].active = false;
        }
        let currentTreatmentIndex = props.details.treatmentAreas.findIndex(
          (item) => item.treatmentAreaId == treatmentArea.id
        );
        if (currentTreatmentIndex > -1)
          props.details.treatmentAreas[currentTreatmentIndex].active = treatmentArea.active;
      }
    };
    const editRoleDetails = () => {
      disableTreatmentArea.value = false;
      resetPrescriberTreatmentArea();
      selectedtreatmentArea.value = null;
      selectedRole.value = null;
      emit('setRoleDetails', 3);
    };
    
    onMounted(() => {
      getTreatmentAreaList();
      getRolesList();
    });

    return {
      treatmentAreaList,
      selectedtreatmentArea,
      saveTreatmentArea,
      rolesList,
      selectedRole,
      saveRoleDetails,
      editRoleDetails,
      disableTreatmentArea,
      disableSave
    };
  }
};
</script>
<style lang="scss" scoped>
.activeInstitution {
  .material-design-icon,
  :deep(.material-design-icon) {
    fill: $teal-darkest;
  }
}
.inActiveInstitution {
  .material-design-icon,
  :deep(.material-design-icon) {
    fill: $gray-lighter;
  }
}
</style>
